import React from "react";
import { detectLevel, formatTime, getMsg, nsToDate } from "../../utils";
import { getAuditFields, formatAuditCell } from "../utils/audit";

export default function LogRow({ styles, r, i, selected, setSelected, cols }) {
  const msg = getMsg(r);
  const lvl = detectLevel(msg);

  const d = nsToDate(r.timestamp);
  const time = d ? formatTime(d) : String(r.timestamp);

  const isSelected = selected && selected.timestamp === r.timestamp && getMsg(selected) === msg;

  const audit = formatAuditCell(getAuditFields(r));
  const action = audit.action || "-";
  const hostMasked = audit.hostCodeMasked || "-";
  const actorUsername = audit.actorUsername || "-";

  const rowStyle = {
    display: "grid",
    gridTemplateColumns: cols,
    gap: 12,
    alignItems: "center",
    padding: "10px 12px",
    cursor: "pointer",
    borderBottom: "1px solid rgba(15,23,42,0.066)",
    background: isSelected ? "rgba(0,108,253,0.07)" : "transparent",
    transition: "background 120ms ease",
  };

  const mono = { fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace" };
  const subtle = { fontSize: 12, opacity: 0.9 };

  return (
    <div
      key={`${r.timestamp}-${i}`}
      style={rowStyle}
      onClick={() =>
        setSelected({
          ...r,
          _lvl: lvl,
          _time: time,
          _msg: msg,
          _audit: audit,
        })
      }
      onMouseEnter={(e) => {
        if (!isSelected) e.currentTarget.style.background = "rgba(15,23,42,0.033)";
      }}
      onMouseLeave={(e) => {
        if (!isSelected) e.currentTarget.style.background = "transparent";
      }}
    >
      <div style={{ ...subtle, ...mono }}>{time}</div>
      <div>
        <span style={styles.badge(lvl)}>{lvl}</span>
      </div>

      <div style={{ ...subtle, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{action}</div>
      <div style={{ ...subtle, ...mono, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
        {hostMasked}
      </div>
      <div style={{ ...subtle, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
        {actorUsername}
      </div>
    </div>
  );
}
